module.exports = __webpack_public_path__ + "img/nombre_en_lettre.9bdfe1ad.jpg";